// src/features/marketplace/components/ListingCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Gauge, Fuel, MapPin, Pin } from 'lucide-react';
import { formatPrice, formatMileage } from '../../../utils/helpers';

export const ListingCard = ({ listing }) => {
  const navigate = useNavigate();
  const flags = listing.flags || [];

  return (
    <div
      onClick={() => navigate(`/market/car/${listing.id}`)}
      className={`bg-white rounded-2xl overflow-hidden border-2 hover:shadow-xl transition-all cursor-pointer group ${
        listing.isPinned 
          ? 'border-amber-400 bg-amber-50' 
          : 'border-gray-200 hover:border-emerald-500'
      }`}
    >
      {/* Image - UŻYJ THUMB zamiast pełnego */}
      <div className="relative aspect-video bg-gray-100 overflow-hidden">
        <img
          src={listing.thumbs?.[0] || listing.images?.[0] || '/placeholder-car.jpg'}
          alt={listing.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        
        {/* Badges Container */}
        <div className="absolute top-2 left-2 flex flex-col gap-2">
          {listing.isPinned && (
            <div className="bg-amber-500 text-white px-2 py-1 rounded-lg text-[10px] font-bold flex items-center gap-1 shadow-lg">
              <Pin size={12} fill="white"/>
              PRZYPIĘTE
            </div>
          )}
          {flags.includes('okazja') && (
            <div className="bg-red-500 text-white px-2 py-1 rounded-lg text-[10px] font-bold shadow-lg">
              🔥 OKAZJA
            </div>
          )}
          {flags.includes('pilne') && (
            <div className="bg-yellow-500 text-white px-2 py-1 rounded-lg text-[10px] font-bold shadow-lg">
              ⚡ PILNE
            </div>
          )}
          {flags.includes('polecane') && (
            <div className="bg-blue-500 text-white px-2 py-1 rounded-lg text-[10px] font-bold shadow-lg">
              ⭐ POLECANE
            </div>
          )}
        </div>

        {/* Price Badge */}
        <div className="absolute bottom-2 right-2 bg-emerald-600 text-white px-3 py-1.5 rounded-lg font-black text-lg shadow-lg">
          {formatPrice(listing.price)}
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-bold text-lg text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors line-clamp-1">
          {listing.title}
        </h3>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Calendar size={16} className="text-gray-400"/>
            <span>{listing.year}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Gauge size={16} className="text-gray-400"/>
            <span>{formatMileage(listing.mileage)}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Fuel size={16} className="text-gray-400"/>
            <span className="capitalize">{listing.fuel}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <MapPin size={16} className="text-gray-400"/>
            <span className="truncate">{listing.location?.name || 'Polska'}</span>
          </div>
        </div>

        {/* CTA */}
        <div className="pt-3 border-t border-gray-100">
          <button className="w-full py-2 bg-emerald-50 text-emerald-600 font-semibold rounded-lg group-hover:bg-emerald-600 group-hover:text-white transition-all">
            Zobacz szczegóły →
          </button>
        </div>
      </div>
    </div>
  );
};
